import { toRadian } from '../utils/string.utilts';
import { LayoutBase } from './LayoutBase';

export default class extends LayoutBase {
  /**
   * 返回指针旋转角度，如果超出范围则代表不渲染，返回undefined
   * @returns
   */
  private getRotation() {
    const { dataItem } = this;
    const node = dataItem as IDataItemPointer;
    const { source, angleRange, angleStart, renderRule = 'alwaysShow' } = node;

    const curData = this.getDataSourceValue(source) as number;

    // 起始值
    const { valueStart, valueRange } = this.getValueStartRange();
    if (!valueRange) return 0;

    // 验证是否超出范围
    const min = Math.min(valueStart, valueStart + valueRange);
    const max = Math.max(valueStart, valueStart + valueRange);
    // 当hideWhenOutRange
    if (
      renderRule === 'hideWhenOutRange' &&
      (curData < min || curData > max)
    ) {
      // console.log('超出角度范围');

      return;
    }

    const ratio = (curData - valueStart) / valueRange;
    // 旋转角度默认值
    let rotation = angleStart + angleRange * ratio;
    // 顺时针旋转
    if (valueRange > 0) {
      if (curData < valueStart) {
        rotation = angleStart;
      } else if (curData > valueRange + valueStart) {
        rotation = angleRange + angleStart;
      }
    }
    // 逆时针旋转
    else if (valueRange < 0) {
      if (curData > valueStart) {
        rotation = angleStart;
      } else if (curData < valueRange + valueStart) {
        rotation = angleRange + angleStart;
      }
    }
    return toRadian(rotation);
  }
  private getPointerImageEl() {
    const { ref } = this.dataItem as IDataItemPointer;
    const { imgEl, src } = this.runtime.getDataItem<IImage>(ref) ?? {};
    return { imgEl, src };
  }
  getSize(): { width: number; height: number } {
    const rotation = this.getRotation();
    if (rotation == undefined) return { width: 0, height: 0 };
    const { imgEl } = this.getPointerImageEl();
    return {
      width: imgEl?.width ?? 0,
      height: imgEl?.height ?? 0
    };
  }
  draw(): void {
    const { ctx, dataItem } = this;
    const { source, pivotX = 0, pivotY = 0 } = dataItem as IDataItemPointer;

    const { imgEl, src: imgSrc } = this.getPointerImageEl();
    if (!source || !ctx || !imgEl) {
      return;
    }

    // 获取旋转角度
    const rotation = this.rotatable ? this.getRotation() : 0;
    if (rotation == undefined) return;

    const { width, height } = imgEl;
    // 离屏画布
    const { canvas: _canvas } = this.getOffscreen({
      width,
      height,
      init: (canvas, ctx) => {
        this.drawRecolorImage(ctx, imgEl, {
          x: 0,
          y: 0
        });
      },
      dirtyParmas: {
        src: imgSrc ?? '',
        pivotX,
        pivotY
      }
    });
    // 普通绘制
    // ctx.drawImage(_canvas, x, y);
    // 动画绘制
    this.drawAniFrame(_canvas, {
      selfRotation: {
        rotation,
        pivotX,
        pivotY
      }
    });
    ctx.restore();

    this.setRuntimeData({
      width,
      height,
      rotation: (rotation * 180) / Math.PI
    });
  }
}
